'use client'; // src/color-mode-script.tsx

import { jsx } from "react/jsx-runtime";
var VALID_VALUES = /* @__PURE__ */new Set(["dark", "light", "system"]);

function normalize(initialColorMode) {
  var value = initialColorMode;
  if (!VALID_VALUES.has(value)) value = "light";
  return value;
}

function getScriptSrc() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _props$initialColorMo = props.initialColorMode,
      initialColorMode = _props$initialColorMo === void 0 ? "light" : _props$initialColorMo,
      _props$type = props.type,
      type = _props$type === void 0 ? "localStorage" : _props$type,
      _props$storageKey = props.storageKey,
      key = _props$storageKey === void 0 ? "chakra-ui-color-mode" : _props$storageKey;
  var init = normalize(initialColorMode);
  var isCookie = type === "cookie";
  var cookieScript = "(function(){try{var a=function(o){var l=\"(prefers-color-scheme: dark)\",v=window.matchMedia(l).matches?\"dark\":\"light\",e=o===\"system\"?v:o,d=document.documentElement,m=document.body,i=\"chakra-ui-light\",n=\"chakra-ui-dark\",s=e===\"dark\";return m.classList.add(s?n:i),m.classList.remove(s?i:n),d.style.colorScheme=e,d.dataset.theme=e,e},u=a,h=\"".concat(init, "\",r=\"").concat(key, "\",t=document.cookie.match(new RegExp(\"(^| )\".concat(r,\"=([^;]+)\"))),c=t?t[2]:null;c?a(c):document.cookie=\"\".concat(r,\"=\").concat(a(h),\"; max-age=31536000; path=/\")}catch(a){}})();\n  ");
  var localStorageScript = "(function(){try{var a=function(c){var v=\"(prefers-color-scheme: dark)\",h=window.matchMedia(v).matches?\"dark\":\"light\",r=c===\"system\"?h:c,o=document.documentElement,s=document.body,l=\"chakra-ui-light\",d=\"chakra-ui-dark\",i=r===\"dark\";return s.classList.add(i?d:l),s.classList.remove(i?l:d),o.style.colorScheme=r,o.dataset.theme=r,r},n=a,m=\"".concat(init, "\",e=\"").concat(key, "\",t=localStorage.getItem(e);t?a(t):localStorage.setItem(e,a(m))}catch(a){}})();\n  ");
  var fn = isCookie ? cookieScript : localStorageScript;
  return "!".concat(fn).trim();
}

function ColorModeScript() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var nonce = props.nonce;
  return /* @__PURE__ */jsx("script", {
    id: "chakra-script",
    nonce: nonce,
    dangerouslySetInnerHTML: {
      __html: getScriptSrc(props)
    }
  });
}

export { getScriptSrc, ColorModeScript };